import { useLocaleStore } from './store';
import { dict, type Namespace, type Keys } from './locales/_index';
import { rebrand } from './brand';

export function useT<NS extends Namespace>(ns: NS) {
  const locale = useLocaleStore((s) => s.locale);
  const table = dict[locale][ns];
  return function t(key: Keys<NS>, vars?: Record<string, string | number>): string {
    const raw = (table as Record<string, string>)[key as string];
    if (raw == null) {
      if (import.meta.env.DEV) {
        console.warn(`[i18n] missing key: ${ns}.${String(key)} (locale=${locale})`);
        return `[${ns}.${String(key)}]`;
      }
      const fallback = (dict.en[ns] as Record<string, string>)[key as string];
      // The English fallback carries the brand too.
      return fallback ? rebrand(fallback) : String(key);
    }
    return rebrand(vars ? interpolate(raw, vars) : raw);
  };
}

function interpolate(s: string, vars: Record<string, string | number>): string {
  return s.replace(/\{(\w+)\}/g, (_, name) => String(vars[name] ?? `{${name}}`));
}
